"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

var _resources = _interopRequireDefault(require("./resources"));

var newInstance = _i18next.default.createInstance();

newInstance.use(_reactI18next.reactI18nextModule).init({
  lng: 'en',
  fallbackLng: 'en',
  resources: _resources.default,
  react: {
    defaultTransParent: 'div'
  }
});
var _default = newInstance;
exports.default = _default;